"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDigraphs = void 0;
const maven_graph_builder_1 = require("./maven-graph-builder");
const newLine = /[\r\n]+/g;
function parseDigraphs(digraphs) {
    const graphs = [];
    for (const digraph of digraphs) {
        const lines = digraph.split(newLine);
        const rootId = findQuotedContents(lines[0]);
        if (!rootId) {
            throw new Error(`Unexpected digraph could not find root node. Could not parse "${lines[0]}".`);
        }
        const builder = new maven_graph_builder_1.MavenGraphBuilder(rootId);
        for (let i = 1; i < lines.length - 1; i++) {
            const line = parseLine(lines[i]);
            if (!line) {
                throw new Error(`Unexpected digraph could not connect nodes. Could not parse "${lines[i]}".`);
            }
            builder.connect(line.from, line.to);
        }
        graphs.push(builder.graph);
    }
    return graphs;
}
exports.parseDigraphs = parseDigraphs;
function parseLine(line) {
    if (!line)
        return null;
    const [left, right] = line.split('->');
    if (!left || !right)
        return null;
    const from = findQuotedContents(left);
    const to = findQuotedContents(right);
    if (!from || !to)
        return null;
    return { from, to };
}
function findQuotedContents(value) {
    if (!value)
        return null;
    const start = value.indexOf('"') + 1;
    const end = value.lastIndexOf('"');
    // when using -Dverbose ensure omitted reasons are parsed correctly
    // https://github.com/apache/maven/blob/ab6ec5bd74af20ab429509eb56fc8e3dff4c7fc7/maven-core/src/main/java/org/apache/maven/internal/impl/DefaultNode.java#L113
    if (value.indexOf('omitted for conflict with') > -1) {
        const [left] = value
            .substring(start + 1, end)
            .split(' - omitted for conflict with ');
        return left;
    }
    if (value.indexOf('omitted for duplicate') > -1) {
        const [left] = value
            .substring(start + 1, end)
            .split(' - omitted for duplicate');
        return left;
    }
    return value.substring(start, end);
}
//# sourceMappingURL=digraph.js.map